import React, {
    useEffect,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import ReactSlider from 'react-slider';
import { useRecoilValue } from 'recoil';
import {RequestedData, userInfo} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
    DropdownMenu,
    Overlay,
    Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import CreatePopup from 'view/pages/Coaching/components/CreatePopup';
import ListItem from 'view/pages/Coaching/components/ListItem';
import RequestPopup from 'view/pages/Coaching/components/RequestPopup';
import ReqListItem from "../components/ReqListItem";
import SortArea from "../components/SortArea";
import EmptyBox from "../../../components/common/EmptyBox";
import {fadeIn, fadeIn3} from "../../../../styled/StyledComponent";
import SearchInputItem from "../../../components/common/SearchInputItem";

const Completed = (props) => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const reqData = useRecoilValue(RequestedData)
    const [list, setList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [coachingTitle, setCoachingTitle] = useState("")
    const [selectClass, setSelectClass] = useState(null);
    const [loading, setLoading] = useState(false);
    const [received, setRceived] = useState(true);
    const [indexValue, setIndexValue] = useState({
        i: 0,
        v: 5,
    });
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const [sortOption, setSortOption] = useState({
        isClassic:true,
        isVideo:true,
        "is24hr":true,
        query:""
    })
    const user = useRecoilValue(userInfo);

    const getClassItem = async () => {
        const result = await classesAPI
            .getClassList({
                //     unpaged:true,
                //    sort:{
                //     sorted:false
                //    },
            })
            .then((res) => {
                setClassList(cloneDeep(res?.content));
                return res?.content;
            });
        return result;
    };

    const getCoachingList = async () => {
        setLoading(true)
        try {
            const result = await coachingAPI
                .getCoachingComplete({
                    params: {
                        isClassic:sortOption.isClassic,
                        is24hr:sortOption.is24hr,
                        isVideo:sortOption.isVideo,
                        page: pageInfo?.number,
                        size: 5,
                    },
                })
                .then((res) => {
                    console.log("coa data", res?.data?.content);
                    setList(cloneDeep(res?.data?.content));
                    setLoading(false)
                    setPageInfo({
                        totalPages: res?.data?.totalPages,
                        number: res?.data?.number,
                        size: res?.data?.size,
                    });
                });
        }catch (e) {
            setLoading(false)

        }

    };

    const getClassItems = () => {
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setSelectClass(cloneDeep(selectItem));
    };

    const createCoaching = async () => {
        coachingAPI.createCoaching({
            params:{
                classesId:selectClass?.id,
                title:coachingTitle
            }
        })
            .then(res => {
                if(res?.success === true && !isEmpty(res?.data?.id)){
                    navigate("/create_coaching/details",{
                        state:{
                            createId:res?.data?.id
                        }
                    })
                }
            })
    };

    console.log('selectClass', selectClass)

    const onClickGetData = (item) => {
        setSelectedData(cloneDeep(item));

        props?.onClickPopup(true);
    };

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    const onChangeSortOption = (key?:any, value?:any) => {
        const c = cloneDeep(sortOption);
        c[key] = value;
        setSortOption(c)
    }

    useEffect(() => {
        getCoachingList();
    }, [pageInfo.number, sortOption.isClassic, sortOption.isVideo, sortOption.is24hr]);

    // useEffect(() => {
    //     getCoachingList(pageInfo?.number);
    // }, [pageInfo.number]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [indexValue?.v]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [selectClass?.id]);

    // useEffect(() => {
    //     getClassItem();
    // }, []);

    console.log("getClassItems()", getClassItems());
    console.log("list",list)

    return (
        <Container>
            {popup && (
                <Overlay filter={true}>
                    <RequestPopup data={selectedData} onClickPopup={()=>{
                        getCoachingList();
                        setPopup(v => !v)
                    }} />
                </Overlay>
            )}
            <ContentsInner>
                <SortArea onChange={onChangeSortOption}
                          data={sortOption} />
                <Status>
                </Status>
                <SearchArea style={{ marginBottom: 15 }}>
                    <DropDownArea
                        style={{width:"30%", opacity:0, pointerEvents:"none"}}>
                        <DropDownWrap
                            className={"newest"}
                        >
                            <DropdownMenu
                                selected={""}
                                altText="Newest"
                                borderColor={"#E5E5E5"}
                                height={40}
                                items={[]}
                            />
                        </DropDownWrap>
                    </DropDownArea>
                    <SearchInputItem/>
                </SearchArea>
                <Wrap>
                    {
                        list?.map((item, index) => {
                            return (
                                <ListWrap index={0.3}>

                                <ReqListItem
                                    userData={user}
                                    rData={item}
                                    data={item}
                                    onClickPopup={(data)=>{
                                        console.log("pData",data)
                                        setSelectedData(data);
                                        setPopup(v => !v)
                                    }}

                                />
                               </ListWrap>
                                    );
                        })}
                    {
                        isEmpty(list) && loading==false &&
                        <EmptyBox url={"/images/nothing.png"} />
                    }
                </Wrap>
            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default Completed;

const Container = styled.div`
    height: 100%;
    position: relative;
    animation: ${fadeIn} 0.4s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */

`;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    position: relative;
    min-height: 550px;
    height: 100%;
`;
const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;
const ListWrap = styled.div<{index?:any}>`
    animation: ${fadeIn3} ${props => props.index}s linear;
`
const StatusCheck = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    p {
        margin-right: 15px;
        font-weight: 700;
        color: "#333";
        font-size: 18px;
    }
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        & > div{
            width: 100%!important;
        }
    }
`;
const DropDownArea = styled.div`
    display: flex;
    width: 50%;
    @media screen and (max-width: 768px) {
        display: none;
    }
`;
const InputArea = styled.div`
    width: 37%;
    display: flex;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    align-items: center;
    flex-direction: row;
    &:hover{
        & > div{
            background: #d5d5d5;

        }
    }
    div {
        transition: all 0.2s;
        height: 100%;
        box-sizing: border-box;
        padding: 0 8px;
        background: #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            padding-bottom: 3px;
        }
        span {
            font-weight: 700;
            font-size: 16px;
            margin-left: 8px;
        }
    }
    input {
        padding-left: 15px;
        outline: none;
        display: flex;
        height: 100%;
        width: 100%;
        flex: 1;
        border-radius: 8px 0 0 8px;
        border: solid 1px #e5e5e5;
        border-right: none;
        &::placeholder {
            opacity: 0.5;
        }
    }
`;
const DropDownWrap = styled.div`
    width: 100%;
    margin-right: 15px;
    @media screen and (max-width: 768px) {
        margin-bottom: 16px;
        &.newest{
            margin-right: 0!important;
        }
    }
`;
const CheckItem = styled.div`
    span {
        margin-left: 5px;
        font-weight: 400;
        font-size: 18px;
    }
    margin-right: 15px;
    display: flex;
    align-items: center;
`;
const Slider = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    h5 {
        font-weight: 700;
        font-size: 18px;
        transform: translate(-20px, -7px);
    }
`;
const IndexItems = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 6px 0 6px;
    margin-top: 16px;
    span {
        text-align: center;
        display: flex;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        justify-content: center;
    }
`;
const SliderWrap = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;

    .horizontal-slider {
        display: flex;
        align-items: center;

        .active {
            width: 16px;
            height: 16px;
            border: solid 1px red;
            background: red;
        }
        span {
            &:nth-child(1) {
                background: #fff;
            }
        }
        .mark {
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #333;
            display: flex;
            align-items: center;
            justify-content: center;

            .indexItem {
                transform: translateY(10px);
            }
            &:first-of-type {
                background: #fff;
                border: solid 2px #333;
            }
            &:last-of-type {
                background: #fff;
                border: solid 2px #333;
            }
        }
        .track {
            height: 8px;
            border-radius: 6px;
            background: #3333331a;
        }
        .track-0 {
            background: #333333;
        }
        .thumb {
            border-radius: 50%;
            height: 16px;
            width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111;
        }
    }
`;
